import React from "react";
import { Link } from "react-router-dom";

import { Button } from "semantic-ui-react";
import htmlParser from "react-html-parser";
import { Container } from "./styles";

function Card({ id, title, img, remove }) {
  return (
    <Container>
      <header>
        <p>{title}</p>
      </header>
      <main>
        <img src={img} alt="Imagem do corpo" />
      </main>
      <footer>
        <Link to={`/admin/ead/certificados/cursos/editar/${id}`}>
          <Button color="secondary">Editar</Button>
        </Link>
        <Button color="red" onClick={() => remove(title, id)}>
          Excluir
        </Button>
      </footer>
    </Container>
  );
}

export default Card;
